export default __webpack_public_path__ + "static/kanerussell-6126bd9961ff8d3ff0ffe745219ce4c8.svg";